import { z } from 'zod'

export const alterarSenhaSchema = z
  .object({
    senhaAtual: z.string().min(1, 'Senha atual é obrigatória'),
    novaSenha: z
      .string()
      .min(8, 'Nova senha deve ter pelo menos 8 caracteres')
      .regex(/[A-Z]/, 'Nova senha deve conter pelo menos uma letra maiúscula')
      .regex(/[a-z]/, 'Nova senha deve conter pelo menos uma letra minúscula')
      .regex(/[0-9]/, 'Nova senha deve conter pelo menos um número')
      .regex(/[^A-Za-z0-9]/, 'Nova senha deve conter pelo menos um caractere especial'),
    confirmarSenha: z.string().min(1, 'Confirmação de senha é obrigatória'),
  })
  .refine((data) => data.novaSenha === data.confirmarSenha, {
    message: 'As senhas não conferem',
    path: ['confirmarSenha'],
  })
  .refine((data) => data.senhaAtual !== data.novaSenha, {
    message: 'A nova senha deve ser diferente da senha atual',
    path: ['novaSenha'],
  })

export type AlterarSenhaFormData = z.infer<typeof alterarSenhaSchema>

export const segurancaSchema = z.object({
  twoFactorEnabled: z.boolean(),
  twoFactorMethod: z.enum(['app', 'sms', 'email']).optional(),
})

export type SegurancaFormData = z.infer<typeof segurancaSchema>

export const defaultSeguranca: SegurancaFormData = {
  twoFactorEnabled: false,
  twoFactorMethod: undefined,
}

export const TWO_FACTOR_METHOD_LABELS: Record<'app' | 'sms' | 'email', string> = {
  app: 'Aplicativo Autenticador',
  sms: 'SMS',
  email: 'E-mail',
}
